export enum PopupType {
  AgeVerifier = 'age',
  Promo = 'promo',
  Signup = 'signup',
}

export type PopupVariant = 'lightbox' | 'flyout'

export interface AgeVerifierData {
  type: PopupType.AgeVerifier
  verified: boolean
  lastShow?: Date | null
}

export interface PromoPopupData {
  type: PopupType.Promo
  lastShow: Date | null
}

export interface SignupPopupData {
  type: PopupType.Signup
  lastShow: Date | null
}

export type PopupData = AgeVerifierData | PromoPopupData | SignupPopupData
export type PopupStorageVariant = 'localStorage' | 'sessionStorage'
